import { v4 as uuid } from 'uuid';
import { BuilderContentType } from 'modules/application/detail/portal-submodule-builder-pipeline/templates/builder/tabs/content/BuilderContentType';
export class BuilderContentService {
    getContentTemplate(type) {
        switch (type) {
            case BuilderContentType.SelectImmediate:
                return {
                    id: uuid(),
                    type: 'application/vnd.lime.select+json',
                    content: {
                        text: 'Select text',
                        scope: 'immediate',
                        options: [
                            {
                                text: 'First option',
                            },
                            {
                                text: 'Second option',
                            },
                        ],
                    },
                };
            case BuilderContentType.Select:
                return {
                    id: uuid(),
                    type: 'application/vnd.lime.select+json',
                    content: {
                        text: 'Select text',
                        options: [
                            {
                                text: 'First option',
                            },
                            {
                                text: 'Second option',
                            },
                            {
                                text: 'Third option',
                            },
                        ],
                    },
                };
            case BuilderContentType.DocumentSelect:
                return {
                    id: uuid(),
                    type: 'application/vnd.lime.collection+json',
                    content: {
                        itemType: 'application/vnd.lime.document-select+json',
                        items: [
                            {
                                header: {
                                    type: 'application/vnd.lime.media-link+json',
                                    value: {
                                        title: 'First title',
                                        text: 'First subtitle',
                                        type: 'image/png',
                                        uri: 'https://s3-sa-east-1.amazonaws.com/msging.net/Services/Images/2e3ff2b4-a8c6-4188-bc0c-0f23531739b2',
                                    },
                                },
                                options: [
                                    {
                                        label: {
                                            type: 'text/plain',
                                            value: 'First option',
                                        },
                                    },
                                    {
                                        label: {
                                            type: 'text/plain',
                                            value: 'Second option',
                                        },
                                    },
                                ],
                            },
                            {
                                header: {
                                    type: 'application/vnd.lime.media-link+json',
                                    value: {
                                        title: 'Second title',
                                        text: 'Second subtitle',
                                        type: 'image/png',
                                        uri: 'https://s3-sa-east-1.amazonaws.com/msging.net/Services/Images/2e3ff2b4-a8c6-4188-bc0c-0f23531739b2',
                                    },
                                },
                                options: [
                                    {
                                        label: {
                                            type: 'text/plain',
                                            value: 'First option',
                                        },
                                    },
                                    {
                                        label: {
                                            type: 'text/plain',
                                            value: 'Second option',
                                        },
                                    },
                                ],
                            },
                        ],
                    },
                };
            case BuilderContentType.Media:
                return {
                    id: uuid(),
                    type: 'application/vnd.lime.media-link+json',
                    content: {
                        title: 'Media link title',
                        text: 'Media link subtitle',
                        type: 'image/png',
                        uri: 'https://s3-sa-east-1.amazonaws.com/msging.net/Services/Images/2e3ff2b4-a8c6-4188-bc0c-0f23531739b2',
                        aspectRatio: '1:1',
                    },
                };
            case BuilderContentType.Sticker:
                return {
                    id: uuid(),
                    type: 'application/vnd.lime.media-link+json',
                    content: {
                        type: 'sticker/webp',
                        uri: 'https://hmgmediastore.blip.ai/public-medias/Media_dd8983c8-8c81-481b-b4c5-53e6540b0768',
                    },
                };
            case BuilderContentType.MediaAudio:
                return {
                    id: uuid(),
                    type: 'application/vnd.lime.media-link+json',
                    content: {
                        type: 'audio/mp3',
                        uri: 'https://blip-community.s3-sa-east-1.amazonaws.com/007.mp3',
                    },
                };
            case BuilderContentType.MediaVideo:
                return {
                    id: uuid(),
                    type: 'application/vnd.lime.media-link+json',
                    content: {
                        type: 'video/mp4',
                        uri: 'http://techslides.com/demos/sample-videos/small.mp4',
                    },
                };
            case BuilderContentType.MediaDocument:
                return {
                    id: uuid(),
                    type: 'application/vnd.lime.media-link+json',
                    content: {
                        title: 'pdf_open_parameters.pdf',
                        type: 'application/pdf',
                        uri: 'https://blip-community.s3-sa-east-1.amazonaws.com/documento-padrao-blip.pdf',
                    },
                };
            case BuilderContentType.ChatState:
                return {
                    id: uuid(),
                    type: 'application/vnd.lime.chatstate+json',
                    content: {
                        state: 'composing',
                        interval: 1000,
                    },
                };
            case BuilderContentType.askLocation:
                return {
                    id: uuid(),
                    type: 'application/vnd.lime.input+json',
                    content: {
                        label: {
                            type: 'text/plain',
                            value: 'Please share your location',
                        },
                        validation: {
                            rule: 'type',
                            type: 'application/vnd.lime.location+json',
                        },
                    },
                };
            case BuilderContentType.sendLocation:
                return {
                    id: uuid(),
                    type: 'application/vnd.lime.location+json',
                    content: {
                        latitude: -19.918899,
                        longitude: -43.959275,
                        altitude: 853,
                        text: 'Take\'s office',
                    },
                };
            case BuilderContentType.SurveyType:
                return {
                    id: uuid(),
                    type: 'application/vnd.lime.satisfaction-survey+json',
                    content: {
                        type: '',
                        scale: '',
                        question: '',
                        score: '',
                    },
                };
            case BuilderContentType.webLink:
                return {
                    id: uuid(),
                    type: 'application/vnd.lime.web-link+json',
                    content: {
                        uri: 'http://limeprotocol.org/content-types.html#web-link',
                        target: 'blank',
                        title: 'Weblink title',
                        text: 'Weblink subtitle',
                    },
                };
            case BuilderContentType.RawContent:
                return {
                    id: uuid(),
                    type: '',
                    content: '',
                };
            case BuilderContentType.ReceiveCallRequest:
                return {
                    id: uuid(),
                    type: 'application/json',
                    content: {
                        recipient_type: 'individual',
                        type: 'interactive',
                        interactive: {
                            type: 'voice_call',
                            body: {
                                'text': 'You can call us on WhatsApp now for faster service!',
                            },
                            action: {
                                name: 'voice_call',
                                parameters: {
                                    display_text: 'Call now',
                                },
                            },
                        },
                    },
                };
            case BuilderContentType.Text:
            default:
                return {
                    id: uuid(),
                    type: 'text/plain',
                    content: 'Some text',
                };
        }
    }
    getContentByAction(action) {
        return {
            document: action.settings,
            editable: true,
        };
    }
    buildActions(contents) {
        const actions = [];
        contents.forEach((c) => actions.push({
            type: 'SendMessage',
            settings: c.document,
        }));
        return actions;
    }
}
